import { useState, useEffect } from 'react';
import useAuth from './useAuth';
import { STOCKITEMS_BASE_URL } from '../config';
import API from '../API';

const initialState = {
  page: 0,
  stockitem: '',
  total_pages: 0,
  total_results: 0,
  imageUrl: '',
};

export const useStockitemFetch = (id) => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const accessToken = auth.auth.accessToken;

  useEffect(() => {
    if (!id) return; // Prevents unnecessary API calls

    const fetchStockitem = async () => {
      try {
        setLoading(true);
        setError(false);

        // Fetch stock item data
        const stockitem = await API.fetchStockitem(id, accessToken);
        const stockitemData = stockitem?.stockitem || initialState;

        let imageUrl = '';
        if (stockitemData.image_path) {
          try {
            const imageResponse = await fetch(
              `${STOCKITEMS_BASE_URL}${stockitemData.image_path}`,
              {
                headers: { Authorization: `Bearer ${accessToken}` },
              }
            );

            if (imageResponse.ok) {
              const blob = await imageResponse.blob();
              imageUrl = URL.createObjectURL(blob);
            }
          } catch (imageError) {
            console.error('Error fetching stock item image:', imageError);
          }
        }

        setState((prevState) => ({
          ...prevState,
          ...stockitemData,
          imageUrl,
        }));
      } catch (error) {
        console.error('Error fetching stock item:', error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchStockitem();

    return () => {
      // Cleanup old image URL to prevent memory leaks
      if (state.imageUrl) {
        URL.revokeObjectURL(state.imageUrl);
      }
    };
  }, [id, trigger]);

  return { state, loading, error, setLoading, setTrigger };
};
